export const defaultBim3DPricingRules = {
  generalSettings: {
    minimumSurface: 500,
    baseJhPerM2: 0.0125,
    urgencyMultiplier: 1.3,
    daysPerPlan: 0.4,
    synthesisOptionEnabled: true,
  },
  lodFactors: { "200": 1.0, "300": 1.2, "350/400": 1.3 },
  loiFactors: {
    "LOI Basique": 1.0,
    "LOI Moyen": 1.1,
    "LOI Détaillé": 1.2,
    "LOI Complet": 1.3,
    "LOI Operations": 1.1,
  },
  disciplineCoefficients: {
    "Architecture": 0.2,
    "Façades Speciales": 0.1,
    "Agencement": 0.45,
    "Structure (Coffrage)": 0.1,
    "Structure (Ferraillage)": 0.2,
    "Electricité": 0.15,
    "Electricité Avancé (Data Centers etc...)": 0.1,
    "CVC": 0.1,
    "Plomberie": 0.1,
  },
  infrastructureCoefficients: {
    "VRD": 0.1,
    "Paysagisme": 0.1,
    "Paysagisme Electricité": 0.1,
  },
  rateTiers: [
    { min: 500, rate: 120 },
    { min: 300, rate: 140 },
    { min: 150, rate: 160 },
    { min: 100, rate: 180 },
    { min: 50, rate: 200 },
    { min: 40, rate: 210 },
    { min: 30, rate: 220 },
    { min: 20, rate: 230 },
    { min: 10, rate: 240 },
    { min: 5, rate: 250 },
    { min: 1, rate: 280 },
    { min: 0, rate: 280 },
  ],
};

export const cloneBim3DPricingRules = () => JSON.parse(JSON.stringify(defaultBim3DPricingRules));